export const textTranslate = (language) => (item = {en: '', el: ''}) => {
	return item[language]
}

export function replaceDotWithComma(text, language) {
	if (language === 'el') {
		// Replace all occurrences of '.' with ','
		return text !== null && text.replace(/\./g, ',');
	}
	// If the language is not 'el', return the original text
	return text;
}

export const toCamelCase = (string) => {
	if (!string) return ''
	const newStringArray = []
	const stringArray = string.split(' ')
	for (let stringPart of stringArray) {
		const firstChar = stringPart[0]
		const afterFirstChar = stringPart.substring(1, stringPart.length)
		newStringArray.push(firstChar.toUpperCase() + afterFirstChar.toLocaleLowerCase())
	}
	return newStringArray.join(' ')
}

export function getCanonicalUrl(relativePath) {
  // Safe origin for browsers (fallback for older browsers)
  const origin =
    typeof window !== "undefined"
      ? window.location.origin ||
        `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? `:${window.location.port}` : ""
        }`
      : "";

  // Return full URL using the URL constructor
  return new URL(relativePath, origin).toString();
}
